import { Table } from 'antd';
import { FormatNumber } from '../../../../_config/functions/format-number.function';
import { dictionaryProductColumn } from '../constants/dictionary-product-columns.constant';
import { checkCategory } from './check-category.handle';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { checkReverse } from './check-reverse.handle';
import { checkReversePrice } from './check-reverse-price.handle';
import '../style.css';

export const generateProductColumns = (handleOpenRecipe, pharmacy) => {
	return [
		Table.EXPAND_COLUMN,
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].name,
			dataIndex: 'name',
			key: 'name',
			render: (name, record) => 	(
				record.category === 'Magistral Recipe' ? (
          <span className="td-name">
            {name}
          </span>
        ) : (
          <a 
            href={`${Enviroment.BASE}/products/${record?.slug}-farmacias-${pharmacy}`} 
            className="td-name" 
            target="_blank" 
            rel="noreferrer"
          >
            {name}
          </a>
        )
				)
			,
		},

		{
			align: 'center',
			title: dictionaryProductColumn[Enviroment.LANGUAGE].quantity,
			dataIndex: 'quantity',
			key: 'quantity',
			render: (quantity, record) => {
				return <span>{checkReverse(record)}</span>;
			},
		},
		{
			align: 'center',
			title: dictionaryProductColumn[Enviroment.LANGUAGE].unit_price,
			dataIndex: 'unit_price',
			key: 'unit_price',
			render: (unit_price) => FormatNumber[Enviroment.LANGUAGE].handleFormat(unit_price),
		},
		{
			align: 'center',
			title: dictionaryProductColumn[Enviroment.LANGUAGE].disscount,
			dataIndex: 'discount',
			key: 'discount',
			render: (discount, record) => {
				return record?.category === 'Magistral Recipe' ? discount + ' %' :
			    discount.toFixed(0) + ' %' }
				// FormatNumber[Enviroment.LANGUAGE].handleFormat(discount)},
		},
		{
			align: 'center',
			title: dictionaryProductColumn[Enviroment.LANGUAGE].final_price_unit,
			dataIndex: 'final_price_unit',
			key: 'final_price_unit',
			render: (final_price_unit, record) => {
				return FormatNumber[Enviroment.LANGUAGE].handleFormat(final_price_unit) }
		},
	
		{
			align: 'center',
			title: dictionaryProductColumn[Enviroment.LANGUAGE].total,
			dataIndex: 'total_product',
			key: 'total_product',
			render: (total, record) => FormatNumber[Enviroment.LANGUAGE].handleFormat(checkReversePrice(record)),
		},
		{
			align: 'center',
			title: dictionaryProductColumn[Enviroment.LANGUAGE].recipe,
			dataIndex: 'recipe',
			key: 'recipe',
			render: (recipe, record) => checkCategory(record, recipe, handleOpenRecipe),
		},
	];
};
